// TanStack Query service for server state management
// Implements data fetching as per Studio1 Architecture

import { QueryClient } from "@tanstack/react-query";
import { logger } from "../services/logger";
import { generateUUID } from "../utils/uuid";

// Create query client with default options
export const createQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
        retry: (failureCount, error: any) => {
          // Don't retry on 4xx errors
          if (error?.response?.status >= 400 && error?.response?.status < 500) {
            return false;
          }
          return failureCount < 3;
        },
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      },
      mutations: {
        retry: 1,
        onError: (error: any) => {
          logger.error("Mutation failed", error as Error, {
            correlationId: generateUUID(),
          });
        },
      },
    },
  });
};
